export const FIELD_STEP_MAPPING: Record<string, number> = {
  name: 0,
  industry: 0,
  sub_industry: 0,
  size: 0,
  country: 0,
  continent: 0,
  tags: 0,
  address: 0,
  website: 0,
  linkedin: 0,
  identification_number: 0,
  custom_field_values: 0,
  lead_type: 0,
  status: 0,

  avatar: 1,
  'contact.first_name': 1,
  'contact.last_name': 1,
  'contact.email': 1,
  'contact.linkedin': 1,
  'contact.senior_position': 1,
  'contact.job_position': 1,
  'contact.phone_numbers': 1,
  'contact.custom_field_values': 1,

  source: 2,
  owner: 2,
  comment: 2
}
